import React, { Component } from 'react';
import moment from 'moment';
import SashiDoTable from 'components/SashiDo/SashiDoTable.react';
import Tooltip from 'react-autotip';
import { nanoSecondsFormat } from 'lib/helpers';

import stylesButton from 'components/Button/Button.scss';
import StatusIndicator from 'components/StatusIndicator/StatusIndicator.react';

import styles from './EngineView.scss';


const STATUS_COLOR = {
  new: 'orange',
  pending: 'lightblue',
  running: 'blue',
  failed: 'red',
  cancelled: 'gray',
  complete: 'green',
  active: 'darkgreen',
};

const STATUS_CONTENT = {
  new: 'NEW',
  pending: 'PENDING',
  running: 'RUNNING',
  failed: 'FAILED',
  cancelled: 'CANCELLED',
  complete: 'COMPLETE',
  active: 'ACTIVE',
};

export default class DeploymentsView extends Component {
  constructor() {
    super();

    this.state = {};
  }

  async componentDidMount() {
    this.props.onLoadComplete();
  }

  cancelHandlerEl = async (name, e) => {
    e.preventDefault();
    e.stopPropagation();

    this.props.cancelHandler(name);
  }

  renderHeaders = () => {
    const headers = [
      <colgroup key="builds_colgroup">
        <col width="100" />
        <col width="180" />
        <col />
        <col width="200" />
      </colgroup>,
      <thead key="builds_thead">
        <tr>
          <th>#</th>
          <th>Created At</th>
          <th>Complete In</th>
          <th>
            <div className={styles.deployments}>Status</div>
          </th>
        </tr>
      </thead>,
    ];
    return headers;
  }

  renderRow(item) {
    const phase = item.phase.toLowerCase();

    let duration = '';

    if (phase && item.duration && phase !== 'cancelled') {
      duration = nanoSecondsFormat(item.duration);
    }

    const color = STATUS_COLOR[phase];
    const status = STATUS_CONTENT[phase];

    const isSpecialStatus = ['running', 'pending', 'new'].includes(phase);

    return (
      <tr key={item.objectId}>
        <td>{item.number}</td>
        <td>
          <Tooltip
            text={<div>{moment(item.createdAt).format('MMM DD YYYY HH:mm')}</div>}
            tooltipStyles={{
              color: '#fff',
              fontFamily: 'Ubuntu',
              fontSize: 14,
              fontWeigt: 300,
              borderRadius: 4,
              maxWidth: 500,
              width: 140,
              unit: 4,
              lightgrey: '#222933',
              opaqueGrey: '#222933',
            }}>
            <span>{moment(item.createdAt).fromNow()}</span>
          </Tooltip>
        </td>
        <td>
          {duration}
        </td>
        <td>
          <div className={[styles.deployments, styles[phase]].join(' ')}>
            <StatusIndicator color={color} status={status} loading={isSpecialStatus} />
            {
              isSpecialStatus
                ?
                <span
                  className={[stylesButton.tableButton, stylesButton.red].join(' ')}
                  onClick={this.cancelHandlerEl.bind(this, item.name)}>
                  Cancel
                  </span>
                : null
            }
          </div>
        </td>
      </tr>
    );
  }

  render() {
    const { deployments } = this.props;

    if (!deployments) {
      return null;
    }

    return (
      <div className={[styles.holder].join(' ')}>
        <div className="box table">
          <SashiDoTable className="hover">
            {this.renderHeaders()}
            <tbody>
              {deployments.map(row => this.renderRow(row))}
            </tbody>
          </SashiDoTable>
        </div>
      </div>
    );
  }
}
